import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import React__default, { forwardRef, useRef, useState } from 'react';
import classNames from 'classnames';
import inputClasses from './cef6c89d744c5246d87e522f9ee03c5c9626c0971b7b8b26e56b662eebc16b13.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useSSRLayoutEffect from '../../hooks/useSSRLayoutEffect/1b5a8c3b5463c14b01e195c9e403e1d1bbb3a66e0ef365e78fe012b249d635d1.cfe-internal.js';

var _excluded = ["type", "initialValue", "value", "onChange", "leftAddOn", "rightAddOn", "className", "style"];
var getAddOnComponent = function getAddOnComponent(addOn, containerClassName, containerRef) {
  if (!addOn) {
    return null;
  }
  var isAddOnAStringOrNumber = typeof addOn === 'string' || typeof addOn === 'number';
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames(containerClassName, _defineProperty({}, inputClasses.addOnTextNode, isAddOnAStringOrNumber)),
    "aria-hidden": isAddOnAStringOrNumber,
    ref: containerRef
  }, addOn);
};
var Input = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    initialValue = _ref.initialValue,
    value = _ref.value,
    onChange = _ref.onChange,
    leftAddOn = _ref.leftAddOn,
    rightAddOn = _ref.rightAddOn,
    externalClassName = _ref.className,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var leftAddOnRef = useRef(null);
  var rightAddOnRef = useRef(null);
  var _useState = useState({
      leftAddOnWidth: 0,
      rightAddOnWidth: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    addOnWidths = _useState2[0],
    setAddOnWidths = _useState2[1];
  var ADD_ON_HORIZONTAL_PADDING = 12;
  useSSRLayoutEffect(function () {
    var leftAddOnWidth = 0;
    var rightAddOnWidth = 0;
    if (leftAddOnRef.current) {
      leftAddOnWidth = leftAddOnRef.current.getBoundingClientRect().width;
    }
    if (rightAddOnRef.current) {
      rightAddOnWidth = rightAddOnRef.current.getBoundingClientRect().width;
    }
    setAddOnWidths({
      leftAddOnWidth: leftAddOnWidth,
      rightAddOnWidth: rightAddOnWidth
    });
  }, [leftAddOn,
  // Re-runs effect when the left add-on changes
  rightAddOn // Re-runs effect when the right add-on changes
  ]);
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames(inputClasses.container, externalClassName),
    style: style
  }, getAddOnComponent(leftAddOn, inputClasses.leftAddOn, leftAddOnRef), /*#__PURE__*/React__default.createElement("input", _extends({}, rest, {
    type: type,
    defaultValue: initialValue,
    value: value,
    onChange: onChange,
    className: inputClasses.input,
    style: {
      paddingLeft: "".concat(addOnWidths.leftAddOnWidth + ADD_ON_HORIZONTAL_PADDING, "px"),
      paddingRight: "".concat(addOnWidths.rightAddOnWidth + ADD_ON_HORIZONTAL_PADDING, "px")
    },
    ref: ref
  })), getAddOnComponent(rightAddOn, inputClasses.rightAddOn, rightAddOnRef));
});

export { Input as default };
